import store from '@/store'
import guards from './guards'

const userRoutes = {
  path: '/user',
  name: 'userDashboard',
  meta: {
    name: 'userDashboard'
  },
  beforeEnter: (to, from, next) => guards.dashboardGuard(next),
  component: () => import(/* webpackChunkName: 'user' */ '@/pages/user/Dashboard.vue'),
  children: [
    {
      path: 'profile',
      name: 'userProfile',
      meta: {
        name: 'userProfile'
      },
      component: () => import(/* webpackChunkName: 'user-profile' */ '@/pages/user/profile/Profile.vue')
    },
    {
      path: 'edit',
      name: 'userEditProfile',
      meta: {
        name: 'userProfile'
      },
      component: () => import(/* webpackChunkName: 'user-profile-edit' */ '@/pages/user/profile/EditProfile.vue')
    },
    {
      path: 'company',
      name: 'userEditCompany',
      meta: {
        name: 'userProfile'
      },
      component: () => import(/* webpackChunkName: 'user-company-edit' */ '@/pages/user/profile/EditCompany.vue')
    },
    {
      path: 'interventions',
      name: 'interventions',
      meta: {
        name: 'interventions'
      },
      beforeEnter: (to, from, next) => {
        let user = store.state.currentUser
        if (user.approved) {
          store.dispatch('firstFetchInter').then(() => next())
        } else {
          next({ name: 'userDashboard' })
        }
      },
      component: () => import(/* webpackChunkName: 'interventions' */ '@/pages/user/interventions/Interventions.vue')
    },
    {
      path: 'interventions/:id/report/:reportId',
      name: 'interventionReport',
      meta: {
        name: 'interventions'
      },
      beforeEnter: (to, from, next) => guards.reportGuard(to, next),
      props: true,
      component: () => import(/* webpackChunkName: 'intervention-report' */ '@/pages/user/interventions/report/InterventionReport.vue')
    },
    {
      path: 'formations',
      name: 'trainings',
      meta: {
        name: 'trainings'
      },
      beforeEnter: (to, from, next) => {
        let user = store.state.currentUser
        if (user.approved) {
          store.dispatch('fetchTrainings').then(() => next())
        } else {
          next({ name: 'userDashboard' })
        }
      },
      component: () => import(/* webpackChunkName: 'trainings' */ '@/pages/user/trainings/Trainings.vue')
    },
    {
      path: 'contact',
      name: 'userContact',
      meta: {
        name: 'contact'
      },
      component: () => import(/* webpackChunkName: 'user-contact' */ '@/pages/user/Contact.vue')
    },
    {
      path: '*',
      name: 'user404',
      meta: {
        from: 'user'
      },
      component: () => import(/* webpackChunkName: 'page-404' */ '@/pages/Page404.vue')
    }
  ]
}

export default userRoutes
